import { render, staticRenderFns } from "./fdInventory16.vue?vue&type=template&id=3a285cca"
import script from "./fdInventory16.vue?vue&type=script&lang=js"
export * from "./fdInventory16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports